import { Entity, EntityRepositoryType, PrimaryKey, Property } from '@mikro-orm/postgresql'
import { EntityRepository } from '@mikro-orm/postgresql'
import { Field } from '../../framework/model-util'
import { BaseEntity } from '../core/core.entities'
import { v4 as uuid } from 'uuid'

class CountryRepository extends EntityRepository<Country> {}

/**
 * Represents a country entity with localized name, priority for sorting,
 * and ISO 2-character country code
 */
@Entity({ repository: () => CountryRepository })
export class Country {
	[EntityRepositoryType]?: CountryRepository

	@PrimaryKey()
	id: string = uuid()

	@Property({ type: 'jsonb' })
	@Field({ type: 'Symbol', localized: true, required: true })
	name: Record<string, string>

	@Property()
	@Field({ type: 'Number', localized: false, required: true })
	priority: number

	@Property()
	@Field({ type: 'Symbol', localized: false, required: true })
	code: string

	constructor(name: Record<string, string>, code: string) {
		this.name = name
		this.code = code
		this.priority = 0
	}
}
